// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divider-line {
    border-bottom: 1px solid #ccc;
    height: 10px;
    /* Other styles, custom box-shadow. Don't change with variable */
    box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.2);
}

.tab-container {
    margin-block-start: 5px;
}

.tab-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-inline: 10px;

    & > * {
        width: 33%;
    }

    & > *:not(:first-child) {
        margin-block-start: 1em;
    }

    .tab-header-title {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;

        & .tab-header-title-content {
            display: flex;
            gap: 10px;
            align-items: center;
            min-width: 150px;
            position: relative;

            [data-default-home-icon-tips] {
                position: absolute;
                display: none;
                top: 60px;
            }
        }

        & p {
            margin-bottom: 5px;
            font-weight: bold;
        }

        & > span {
            margin-top: 0;
            color: grey;
        }

        & .tab-header-action-buttons-content {
            display: none;

            & > * {
                background-color: var(--outline);

                &:hover {
                    background-color: var(--surface-variant-transparency);
                    transition: background-color 0.5s ease-in-out color 0.5s ease-in-out;
                    cursor: pointer;
                }
            }

            & > md-icon {
                font-size: 24px;
            }
        }
    }
}

.tab-content-layout {
    margin-block-start: 10px;
}

[data-report-pdf-icon] {
    display: none;
}

.order-by-update-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

[data-order-by-update-container-responsive] {
    display: none;
    width: 100%;
}

@media (width < 900px) {
    .tab-header {
        flex-wrap: wrap;
    }

    .tab-header .tab-header-title {
        order: 1;
        width: 50%;
    }

    .tab-header [data-tab-buttons] {
        order: 3;
        width: 100%;
    }

    .tab-header [data-order-by-update-container] {
        order: 2;
        width: 50%;
    }
}

@media (width < 640px) {
    .divider-line {
        margin-block-start: 35px;
    }
}

@media (width <= 550px) {
    [data-order-by-update-container-responsive] {
        display: flex;
    }

    [data-order-by-update-container] {
        display: none;
    }

    .tab-header-title {
        width: 100% !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/TabsLayout/TabsLayout.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,YAAY;IACZ,gEAAgE;IAChE,6CAA6C;AACjD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,oBAAoB;;IAEpB;QACI,UAAU;IACd;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;;QAER;YACI,aAAa;YACb,SAAS;YACT,mBAAmB;YACnB,gBAAgB;YAChB,kBAAkB;;YAElB;gBACI,kBAAkB;gBAClB,aAAa;gBACb,SAAS;YACb;QACJ;;QAEA;YACI,kBAAkB;YAClB,iBAAiB;QACrB;;QAEA;YACI,aAAa;YACb,WAAW;QACf;;QAEA;YACI,aAAa;;YAEb;gBACI,gCAAgC;;gBAEhC;oBACI,qDAAqD;oBACrD,oEAAoE;oBACpE,eAAe;gBACnB;YACJ;;YAEA;gBACI,eAAe;YACnB;QACJ;IACJ;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".divider-line {\n    border-bottom: 1px solid #ccc;\n    height: 10px;\n    /* Other styles, custom box-shadow. Don't change with variable */\n    box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.2);\n}\n\n.tab-container {\n    margin-block-start: 5px;\n}\n\n.tab-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding-inline: 10px;\n\n    & > * {\n        width: 33%;\n    }\n\n    & > *:not(:first-child) {\n        margin-block-start: 1em;\n    }\n\n    .tab-header-title {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n\n        & .tab-header-title-content {\n            display: flex;\n            gap: 10px;\n            align-items: center;\n            min-width: 150px;\n            position: relative;\n\n            [data-default-home-icon-tips] {\n                position: absolute;\n                display: none;\n                top: 60px;\n            }\n        }\n\n        & p {\n            margin-bottom: 5px;\n            font-weight: bold;\n        }\n\n        & > span {\n            margin-top: 0;\n            color: grey;\n        }\n\n        & .tab-header-action-buttons-content {\n            display: none;\n\n            & > * {\n                background-color: var(--outline);\n\n                &:hover {\n                    background-color: var(--surface-variant-transparency);\n                    transition: background-color 0.5s ease-in-out color 0.5s ease-in-out;\n                    cursor: pointer;\n                }\n            }\n\n            & > md-icon {\n                font-size: 24px;\n            }\n        }\n    }\n}\n\n.tab-content-layout {\n    margin-block-start: 10px;\n}\n\n[data-report-pdf-icon] {\n    display: none;\n}\n\n.order-by-update-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n[data-order-by-update-container-responsive] {\n    display: none;\n    width: 100%;\n}\n\n@media (width < 900px) {\n    .tab-header {\n        flex-wrap: wrap;\n    }\n\n    .tab-header .tab-header-title {\n        order: 1;\n        width: 50%;\n    }\n\n    .tab-header [data-tab-buttons] {\n        order: 3;\n        width: 100%;\n    }\n\n    .tab-header [data-order-by-update-container] {\n        order: 2;\n        width: 50%;\n    }\n}\n\n@media (width < 640px) {\n    .divider-line {\n        margin-block-start: 35px;\n    }\n}\n\n@media (width <= 550px) {\n    [data-order-by-update-container-responsive] {\n        display: flex;\n    }\n\n    [data-order-by-update-container] {\n        display: none;\n    }\n\n    .tab-header-title {\n        width: 100% !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
